const PT = require("prop-types");
const React = require("react");

const styles = require("./styles/ArrowIcon.css");
const colorStyles = require("./styles/Colors.css");

const ArrowIcon = function(props) {
	const {
		arrowClass,
		direction = "right",
		disabled = false,
		colorName = "red",
		type = "standard",
		useScaleHoverEffect = false,
		size = 1,
		useColorHoverEffect = false,
		useWonkyCursor = false,
		circleColor = false,
		tail = false,
	} = props;

	const classes = [styles.main];
	const style = {};

	const arrowClasses = [styles.arrow];
	if (arrowClass) arrowClasses.push(arrowClass);

	if (size === "fit") {
		style.width = "100%";
		style.height = "100%";
	} else if (type === "tall") {
		style.width = 2 * size + "rem";
		style.height = 4 * size + "rem";
	} else {
		style.width = 2 * size + "rem";
		style.height = 2 * size + "rem";
	}

	if (!disabled) {
		arrowClasses.push(styles.arrowPointer);
		style.cursor = useWonkyCursor
			? "url(/assets/images/cursors/wonky-hand-point.cur), pointer"
			: "pointer";
		if (useColorHoverEffect) {
			arrowClasses.push(colorStyles[colorName + "ColorHoverEffect"]);
			arrowClasses.push(styles.arrowHoverEffect);
		} else if (colorName !== "none") {
			arrowClasses.push(colorStyles[colorName + "Color"]);
		}
	}

	if (useScaleHoverEffect) arrowClasses.push(styles.hoverableArrow);

	const degreesByDirection = {
		up: 180,
		down: 0,
		left: 90,
		right: -90,
	};

	let degrees = degreesByDirection[direction];

	let arrowEl;

	if (type === "filled") {
		classes.push(styles["degree" + degrees]);

		arrowEl = (
			<div className={classes.join(" ")} style={style}>
				<svg
					x="0px"
					y="0px"
					viewBox="0 0 12 12"
					width="12"
					height="12"
					preserveAspectRatio="none"
					className={arrowClasses.join(" ")}
				>
					<path d="m1.65,3.2c-0.7,0 -0.8,0.4 -0.4,0.9l3.9,4.2c0.5,0.5 1.2,0.5 1.6,0l3.9,-4.2c0.5,-0.5 0.3,-0.9 -0.4,-0.9l-8.6,0z" />
				</svg>
			</div>
		);
	} else if (type === "wonky") {
		degrees += 90;
		classes.push(styles["degree" + degrees]);

		arrowEl = (
			<div className={classes.join(" ")} style={style}>
				<svg
					x="0px"
					y="0px"
					viewBox="0 0 30 30"
					width="30"
					height="30"
					preserveAspectRatio="none"
					className={arrowClasses.join(" ")}
				>
					<path d="m8.35,27.5c-1.5,-1 -0.9,-24.5 1.1,-25c2,-0.5 13.7,10.3 13.2,13.3c-0.4,3 -12.7,12.7 -14.3,11.7" />
				</svg>
			</div>
		);
	} else if (type === "tail-wonky") {
		classes.push(styles["degree" + degrees]);
		arrowEl = (
			<div className={classes.join(" ")} style={style}>
				<svg
					x="0px"
					y="0px"
					viewBox="0 0 30 30"
					width="30"
					height="30"
					preserveAspectRatio="none"
					className={arrowClasses.join(" ")}
				>
					<polygon points="1.5,14.3 15.1,26.2 28.3,13.4 18.6,13 19.1,5.2 8,6.5 9.3,12.8  " />
				</svg>
			</div>
		);
	} else if (type === "sharp") {
		const className = classes.join(" ");

		arrowEl = (
			<div className={className} style={style}>
				<svg
					x="0px"
					y="0px"
					viewBox="0 0 30 30"
					width="30"
					height="30"
					preserveAspectRatio="none"
					className={arrowClasses.join(" ")}
				>
					<g transform={`rotate(${degrees} 15, 15)`}>
						<polygon points="2.3,8.4 15.5,21.6 27.7,8.7 " />
					</g>
				</svg>
			</div>
		);
	} else if (type === "thin-sharp") {
		const className = classes.join(" ");

		arrowEl = (
			<div className={className} style={style}>
				<svg
					x="0px"
					y="0px"
					viewBox="0 0 30 30"
					width="30"
					height="30"
					preserveAspectRatio="none"
					className={arrowClasses.join(" ")}
				>
					<g transform={`rotate(${degrees} 15, 15)`}>
						<polygon points="2.261066436767578,0.7914199829101562 15.501531600952148,29.208580315113068 27.738933563232422,1.437264859676361 " />
					</g>
				</svg>
			</div>
		);
	} else if (type === "tall") {
		degrees += 90;
		classes.push(styles["degree" + degrees]);

		arrowEl = (
			<div className={classes.join(" ")} style={style}>
				<svg
					viewBox="0 0 125 330"
					width="125"
					height="330"
					x="0px"
					y="0px"
					className={arrowClasses.join(" ")}
				>
					<path d="M12.1,328.4c-2.1,0-4.2-0.6-6.1-1.8C1,323.2-0.4,316.4,3,311.3L99.7,165L3,18.7C-0.4,13.6,1,6.8,6.1,3.4c5.1-3.3,11.9-2,15.2,3.1L122,158.9c2.4,3.7,2.4,8.5,0,12.1L21.3,323.5C19.2,326.7,15.7,328.4,12.1,328.4z" />
				</svg>
			</div>
		);
	} else if (type === "invisible") {
		// no cursor for an invisible element
		delete style.cursor;
		// blank element
		arrowEl = <div style={style} />;
	} else {
		degrees += 90;
		classes.push(styles["degree" + degrees]);

		const arrowSize = circleColor
			? "calc(" + 4 * size + "rem" - "10%)"
			: 4 * size + "rem";
		if (size === "fit") {
			if (tail) {
				style.width = circleColor ? "80%" : "100%";
			} else {
				style.width = circleColor ? "40%" : "50%";
			}
			style.height = circleColor ? "80%" : "100%";
		} else {
			style.height = arrowSize;
			styles.width = tail ? arrowSize : arrowSize / 2;
		}

		let width = 20;
		let tailPath;
		let startingX = 18.28726;
		if (tail) {
			tailPath = <path d="m5,18l32,0l0,4,l-29,0,l0,-4z" />;
			startingX += 20;
			width += 20;
		}
		const arrowPath = `m${startingX},18.60011l-13.6,-13.6c-0.8,-0.8 -2,-0.8 -2.8,0c-0.8,0.8 -0.8,2 0,2.8l12.3,12.3l-12.4,12.3c-0.8,0.8 -0.8,2 0,2.8c0.4,0.4 0.9,0.6 1.4,0.6s1,-0.2 1.4,-0.6l13.6,-13.6c0.4,-0.4 0.6,-1 0.6,-1.5c0.1,-0.5 -0.1,-1.1 -0.5,-1.5z`;

		const viewBox = `0 0 ${width} 40`;
		arrowEl = (
			<div className={classes.join(" ")} style={style}>
				<svg
					version="1.1"
					x="0px"
					y="0px"
					viewBox={viewBox}
					width={width}
					height="40"
					preserveAspectRatio="none"
					className={arrowClasses.join(" ")}
				>
					<path d={arrowPath} />
					{tailPath}
				</svg>
			</div>
		);
	}

	if (circleColor) {
		const circleHeight = size === "fit" ? "100%" : 4 * size + "rem";
		const circleStyle = {
			width: circleHeight,
			height: circleHeight,
			backgroundColor: circleColor,
		};
		style.left = "4%";
		return (
			<div className={styles.circle} style={circleStyle}>
				{arrowEl}
			</div>
		);
	} else {
		return arrowEl;
	}
};

ArrowIcon.propTypes = {
	direction: PT.oneOf(["up", "down", "left", "right"]),
	type: PT.oneOf([
		"filled",
		"wonky",
		"sharp",
		"standard",
		"tail-wonky",
		"thin-sharp",
		"tall",
		"invisible",
	]),
	useScaleHoverEffect: PT.bool,
	useColorHoverEffect: PT.bool,
	useWonkyCursor: PT.bool,
	disabled: PT.bool,
	colorName: PT.string,
	arrowClass: PT.string,
	size: PT.oneOfType([PT.number, PT.oneOf(["fit"])]),
	circleColor: PT.string,
	tail: PT.bool,
};

module.exports = ArrowIcon;
